import React from "react"
import {Application, isBusinessApplication} from "../../resources/application"
import {useIsAllowedToPreviewApprovalRejectInformation} from "../../containers/PermissionedUser/PermissionedUser"
import {ApplicationDecision} from "./ApplicationDecision"

export function OnboardingApplicationDecision({
	application,
	fieldClassName,
}: {
	application: Application
	fieldClassName?: string
}) {
	const canViewDecision = useIsAllowedToPreviewApprovalRejectInformation()
	const {
		status,
		decisionMethod,
		decisionDateTime,
		decisionReason,
		decisionReasonCodes,
		decisionUserId,
		decisionBy,
		riskRate,
		archived,
	} = application.attributes

	return (
		<ApplicationDecision
			canViewDecision={canViewDecision}
			status={status}
			decisionMethod={decisionMethod}
			decisionDateTime={decisionDateTime}
			decisionReason={decisionReason}
			decisionReasonCodes={decisionReasonCodes}
			decisionUserId={decisionUserId}
			decisionBy={decisionBy}
			riskRate={riskRate}
			archived={archived}
			showEvaluationType={isBusinessApplication(application) && application.attributes.externalCip === true}
			fieldClassName={fieldClassName}
		/>
	)
}
